import { Pipe, PipeTransform } from '@angular/core';

/** @deprecated - this is moved to libs */
@Pipe({
    name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
    transform(input: string): string {
        if (input === undefined) {
            return;
        }

        return input.charAt(0).toUpperCase() + input.substr(1).toLowerCase();

    }
}
